const tooltipCommentFlagIcon = {
  tooltip: 'La pregunta tiene opción de comentario',
  tooltipFileFlag: 'La pregunta tiene opción de archivo',
};

export default tooltipCommentFlagIcon;
